import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { AssessmentDataService } from "providers/asmt-data-service/asmt-data-service";
const dateTimeFormat = "MM/DD/YYYY HH:mm";
/**
 * Generated class for the FormCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "form-card-with-previous",
  templateUrl: "form-card-with-previous.html",
})
export class FormCardWithPreviousComponent implements OnInit {
  id: any;
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;

  cardId: string;
  label: string;
  declinable: boolean;
  cardData: any;
  prevRow: any[] = [];
  colHeaders: string[];
  seeMoreLength: number = 0;

  constructor(public dataService: AssessmentDataService) {}

  ngOnInit(): void {
    this.cardId = this.config.id;
    this.label = this.config.cardName;
    this.declinable = this.config.declinable;
    this.colHeaders = this.config.data.listHeaders;
    let inputKeys = Object.keys(this.config.inputs);

    for (let key of inputKeys) {
      if (key === "chiefCompliant" || key === "historyOfPresentIllness") {
        if (
          this.config.inputs[key].rules &&
          this.config.inputs[key].rules.seeMoreLength
        ) {
          this.seeMoreLength = this.config.inputs[key].rules.seeMoreLength;
        }
      }
    }
  }

  @Input() set data(incomingData: any) {
    if (incomingData) {
      this.cardData = incomingData[0];
      let rows = incomingData.filter(
        (x) => x.assessmentId != this.assessmentId.toString()
      );
      for (let data of rows) {
        let parsedData = this.parseDataRow(data);
        this.prevRow.push(parsedData);
      }
    }
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      if (typeof data[key] == "object") {
        let innerObj = data[key];
        if (innerObj == undefined) {
          continue;
        }
      } else {
        flatData[key] = data[key];
      }
    }
    return flatData;
  }

  parseDataRow(data: object) {
    let values = {};
    let flatData = this.flattenIncomingData(data);
    for (let header of this.colHeaders) {
      let val = "-";
      if (flatData[header] || flatData[header] === 0) {
        if (header === "date") {
          flatData[header] = moment(flatData[header]).format(dateTimeFormat);
        }
        val = flatData[header];
      } else if (header === "createdBy") {
        flatData[header] = flatData["addedBy"];
        if (flatData["credentials"]) {
          flatData[header] =
            flatData["addedBy"] + " " + flatData["credentials"];
        }
        val = flatData[header];
      }
      values[header] = val;
    }
    return values;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/form-card-with-previous/form-card-with-previous.ts